module.exports = __webpack_public_path__ + "img/sph-ewm.150b1912.jpg";